import { PauseCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function PointsPausedNotice() {
  const { user } = useAuth();
  if (!user?.no_points && !user?.points_frozen) return null;
  const paused = user.no_points;
  return (
    <div className="flex items-start gap-3 p-4 rounded-3xl bg-amber-50 border border-amber-200 text-amber-900" data-testid="points-paused-notice">
      <PauseCircle className="w-6 h-6 shrink-0 text-amber-500" />
      <div>
        <p className="font-bold">{paused ? "Dein Punkte-Sammeln ist pausiert" : "Dein Guthaben ist eingefroren"}</p>
        <p className="text-sm">{paused ? "Du bekommst gerade keine neuen Punkte und kannst deine Punkte nicht einlösen oder einsetzen." : "Du sammelst weiter Punkte, kannst sie aber gerade nicht einlösen oder einsetzen."} Bei Fragen melde dich gern beim itzPlay-Team.</p>
      </div>
    </div>
  );
}
